'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  checkboxesSpacing: (0, _reactackleCore.bmodule)(1),
  input: {
    size: (0, _reactackleCore.bmodule)(2.25),
    cursor: 'pointer',
    borderWidth: 1,
    // Only numbers accepted
    borderRadius: _reactackleCore.radiusDefault,
    backgroundColor: _reactackleCore.colorTransparent,
    borderColor: _reactackleCore.colorPaletteGrey300,
    hover: {
      backgroundColor: _reactackleCore.colorTransparent,
      borderColor: _reactackleCore.colorPaletteGrey500
    },
    focus: {
      backgroundColor: _reactackleCore.colorTransparent,
      borderColor: _reactackleCore.colorSecondary
    },
    disabled: {
      backgroundColor: _reactackleCore.colorPaletteGrey100,
      borderColor: _reactackleCore.colorPaletteGrey300
    },
    checked: {
      backgroundColor: _reactackleCore.colorSecondary,
      borderColor: _reactackleCore.colorSecondary,
      hover: {
        backgroundColor: _reactackleCore.colorSecondary,
        borderColor: _reactackleCore.colorSecondary
      },
      focus: {
        backgroundColor: _reactackleCore.colorSecondary,
        borderColor: _reactackleCore.colorSecondary
      },
      disabled: {
        backgroundColor: _reactackleCore.colorPaletteGrey200,
        borderColor: _reactackleCore.colorPaletteGrey300
      }
    }
  },
  icon: {
    size: (0, _reactackleCore.bmodule)(2),
    imgSize: null,
    element: _react2.default.createElement(_reactackleIcons.IconCheck, {
      size: 'custom',
      color: 'currentColor'
    }),
    style: {
      color: _reactackleCore.colorTransparent,
      opacity: 1,
      hover: {
        color: _reactackleCore.colorWhite,
        opacity: 0.3
      },
      focus: {
        color: _reactackleCore.colorWhite,
        opacity: 0.5
      },
      disabled: {
        color: _reactackleCore.colorTransparent,
        opacity: 1
      },
      checked: {
        color: _reactackleCore.colorWhite,
        opacity: 1,
        hover: {
          color: _reactackleCore.colorWhite,
          opacity: 0.6
        },
        focus: {
          color: _reactackleCore.colorWhite,
          opacity: 0.6
        },
        disabled: {
          color: _reactackleCore.colorWhite,
          opacity: 0.75
        }
      }
    }
  },
  label: {
    checkboxTextSpacing: (0, _reactackleCore.bmodule)(1),
    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeBody,
    fontColor: _reactackleCore.colorPaletteGrey900,
    lineHeight: 1.5,
    disabled: {
      color: _reactackleCore.colorPaletteGrey500
    }
  },
  errorMessage: {
    messageCheckboxSpacing: (0, _reactackleCore.bmodule)(0.5),
    fontSize: _reactackleCore.fontSizeSmall,
    fontColor: _reactackleCore.colorError,
    lineHeight: 1.25
  }
};